module.exports = __webpack_public_path__ + "static/img/p-17.bf87bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-17.png
// module id = pjvj
// module chunks = 0